import { ButtonVariant } from "@/libraries/design/components/button/src/button";
import Hero, {
    HeroLayoutProps,
    HeroBackgroundColors
} from "@/libraries/design/patterns/hero/src/hero";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";

export type UniformHeroSectionProps = {
    heading: string;
    size?: "large" | "regular";
    subheading?: string;
    backgroundColor?: HeroBackgroundColors;
    layout?: HeroLayoutProps;
    buttonHref?: {
        path: string;
    };
    buttonLabel?: string;
    buttonVariant?: ButtonVariant;
    imageUrl?: string;
    imageAlt?: string;
    secondaryImageUrl?: string;
};

const UniformHeroSection = (props: UniformHeroSectionProps) => {
    const localizedButtonHref = useLocalizedHref(props.buttonHref?.path ?? "");

    return (
        <Hero
            heading={props.heading}
            size={props.size}
            subheading={props.subheading}
            layout={props.layout ?? "image-right"}
            backgroundColor={props.backgroundColor}
            callToActionProps={
                props.buttonHref && props.buttonLabel
                    ? {
                          text: props.buttonLabel,
                          href: localizedButtonHref,
                          variant: props.buttonVariant ?? "primary",
                          dataEventProps: {
                              "data-product-key": "uniform",
                              "data-event": "clicked",
                              "data-event-component": "linkButton",
                              "data-event-container": "heroSection"
                          }
                      }
                    : undefined
            }
            imageProps={
                props.imageUrl
                    ? {
                          src: props.imageUrl,
                          alt: props.imageAlt ?? ""
                      }
                    : undefined
            }
            secondaryImageProps={
                props.secondaryImageUrl
                    ? {
                          src: props.secondaryImageUrl,
                          alt: ""
                      }
                    : undefined
            }
        />
    );
};

export default UniformHeroSection;
